import { useSetAtom } from 'jotai';
import { useParams } from 'react-router-dom';

import { useGetClientUserPaperwork as useSeedlingGetClientUserPaperwork } from '@grow-therapy-team/seedling-components';

import { logger } from '../../datadog';
import { visitorMeasuresAtom } from '../state';
import { useGetClientUserShortId } from './useGetClientUserShortId';

export function useGetClientUserPaperwork() {
  const clientUserShortId = useGetClientUserShortId();
  const { providerShortId } = useParams() as { providerShortId: string };

  const setVisitorMeasures = useSetAtom(visitorMeasuresAtom);

  return useSeedlingGetClientUserPaperwork(clientUserShortId, providerShortId, {
    onCompleted(data) {
      setVisitorMeasures(data.outstandingMeasures || []);
    },
    onError(error) {
      logger.error('Error fetching outstanding measures', { clientUserShortId, providerShortId, error });
      setVisitorMeasures([]);
    },
    // While not strictly required, omitting the provider short ID will return
    // *all* measures, rather than just the ones for a specific patient-provider
    // relationship.
    skip: !providerShortId,
  });
}
